<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
import numeral from 'numeral';

export default {
    data() {
        var that = this;

        return {
            tableName: 'TRANSACTION_BREAKDOWN',
            columns: [
                'receipt_date',
                'total',
                'total_cash',
                'total_credit_card',
                'total_cheque',
                'total_voucher',
                'total_others',
                'total_M1',
            ],
            options: {
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                texts: {
                    title: 'Transaction Breakdown',
                    description:
                        'Shows transaction breakdown by payment method',
                },
                pdf_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'XLSX' },
                ),

                responseAdapter: res => {
                    const data = res.data.data.map(data => {
                        return {
                            receipt_date: moment(data.receipt_date).format(
                                'dddd, DD/MM/YYYY',
                            ),
                            total: this.numberFormat(data.total),
                            total_cash: this.numberFormat(data.total_cash),
                            total_credit_card: this.numberFormat(
                                data.total_credit_card,
                            ),
                            total_cheque: this.numberFormat(data.total_cheque),
                            total_voucher: this.numberFormat(
                                data.total_voucher,
                            ),
                            total_others: this.numberFormat(data.total_others),
                            total_M1: this.numberFormat(data.total_M1),
                        };
                    });

                    return {
                        data,
                        count: res.data.count,
                    };
                },
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route('franchise.report.transaction.breakdown');
        },
    },

    methods: {
        numberFormat(total) {
            return numeral(total).format('0,0.00');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/transaction-breakdown.vue